import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { DeliveryMethodBadge } from "../../common/delivery-method-badge";

const catalogEntry = fgColumnEntries["delivery-method"];

export const DeliveryMethodColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => {
    return (
      row.deliveryMethod && (
        <Flex px="lg">
          <DeliveryMethodBadge deliveryMethod={row.deliveryMethod} />
        </Flex>
      )
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
